import '../css/flipcard.css';
import LanguageDetect from 'languagedetect';
import {assignCharPoint} from '../io/charDetect';
import visibleIcon from "../assets/visible.png";
import hiddenIcon from "../assets/hidden.png";

const lngDetector = new LanguageDetect();

export const FlipCard = ({props} ) => {
  const {
    sideToShow,
    isFront,
    front,
    back,
    frontAdditional,
    backAdditional,
    onClick,
    dragXY,
    flyOff,
    flyOffDurationMs,
    disableFlipTransition,
    muted,
    flagStatus,
    onToggleMuted,
    onCycleFlagStatus,
    editMode,
    editValues,
    onEditFieldChange,
  } = props;
  const frontText = (front || '').trim();
  const backText = (back || '').trim();
  const frontAdditionalText = (frontAdditional || '').trim();
  const backAdditionalText = (backAdditional || '').trim();
  const startsOnBack =
    sideToShow === true || sideToShow === 1 || sideToShow === "1";
  const showsFront = !!isFront !== startsOnBack;
  const innerFlip = `${showsFront ? "" : "is-flipped "}card-flipper${
    disableFlipTransition ? " is-transition-suppressed" : ""
  }`;
  let lang = lngDetector.detect(frontText); 
  let langClass=''
  if ( lang.length > 0) {
    if (['hebrew'].includes(lang[0][0])) {
      langClass = ' hebrew'; 
    } else if (['nepali', 'hindi'].includes(lang[0][0])) {
      langClass=' hindi'
    }
  } else if (lang.length === 0) {
    let charBlock = assignCharPoint(frontText.codePointAt(0));
    if (charBlock === 'devanagari' ) langClass = ' hindi';
    else if (charBlock === 'hebrew' ) langClass = ' hebrew';
    else if (['hiragana','katakana'].includes(charBlock)) langClass = ' japanese';
  }
  let degs = dragXY.current[0]*dragXY.current[0] / 175 / 175 * 10;
  const styleDrag = {
    transform: `translate(${dragXY.current[0]}px, ${dragXY.current[1]}px) rotateZ(${degs}deg)`,
  };
  const flyOffStyle = flyOff ? {
    transform: `translate(${flyOff.targetX}px, ${flyOff.targetY}px) rotateZ(${flyOff.rotation}deg)`,
    transition: `transform ${flyOffDurationMs ?? 220}ms ease-out`,
  } : {};
  
  const smallerFront = frontText.length > 50 ? frontText.length > 150 ? " smallest-text" : " smaller-text" : "";
  const smallerBack = backText.length > 50 ? backText.length > 150 ? " smallest-text" : " smaller-text" : "";
  const activePrimaryField = showsFront ? "front" : "back";
  const activeSecondaryField = showsFront ? "frontAdditional" : "backAdditional";
  const activePrimaryValue = editValues?.[activePrimaryField] ?? "";
  const activeSecondaryValue = editValues?.[activeSecondaryField] ?? "";
  const activeFaceClass = showsFront
    ? `card-flipper__face card-flipper__face--front${langClass}${smallerFront}`
    : `card-flipper__face card-flipper__face--back${smallerBack}`;
  const flagClass = `card-flag-indicator${
    flagStatus === "flagged"
      ? " is-flagged"
      : flagStatus === "reverse_required"
        ? " is-reverse-required"
        : ""
  }`;
  const renderControls = () => (
    <div className="card-face-controls">
      <button
        type="button"
        className="card-control-button card-mute-toggle"
        onClick={(event) => {
          event.stopPropagation();
          onToggleMuted?.();
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onTouchStart={(event) => {
          event.stopPropagation();
        }}
        onTouchEnd={(event) => {
          event.stopPropagation();
        }}
        onPointerDown={(event) => {
          event.stopPropagation();
        }}
      >
        <span className="card-mute-icon-wrapper">
          <img
            alt={muted ? "Muted" : "Visible"}
            className="card-mute-icon"
            src={muted ? hiddenIcon : visibleIcon}
          />
        </span>
      </button>
      <button
        type="button"
        className={flagClass}
        onClick={(event) => {
          event.stopPropagation();
          onCycleFlagStatus?.();
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onTouchStart={(event) => {
          event.stopPropagation();
        }}
        onTouchEnd={(event) => {
          event.stopPropagation();
        }}
        onPointerDown={(event) => {
          event.stopPropagation();
        }}
      >
        {flagStatus === "reverse_required" ? (
          <span className="card-flag-label">R</span>
        ) : null}
      </button>
    </div>
  );

  const renderEditor = () => (
    <div className="card-flipper__content card-flipper__content--editor">
      <input
        type="text"
        className="card-editor-inline card-editor-inline--primary"
        value={activePrimaryValue}
        onChange={(event) =>
          onEditFieldChange?.(activePrimaryField, event.target.value)
        }
        onClick={(event) => event.stopPropagation()}
      />
      <textarea
        rows={4}
        className="card-editor-inline card-editor-inline--secondary"
        value={activeSecondaryValue}
        onChange={(event) =>
          onEditFieldChange?.(activeSecondaryField, event.target.value)
        }
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
  
  return (
    <>
    <div className="draggable" style={{...styleDrag, ...flyOffStyle}}>
    <div className="scene scene--card-flipper">
  <div onClick={onClick} className="card-flipper-shell">
  {editMode ? (
  <div className="card-flipper card-flipper--editor">
    <div className={`${activeFaceClass} card-flipper__face--editor`}>
      {renderControls()}
      {renderEditor()}
    </div>
  </div>
  ) : (
  <div className={innerFlip}>
    <div className={"card-flipper__face card-flipper__face--front" + langClass + smallerFront}>
      {renderControls()}
      <div className="card-flipper__content">
        <div className="card-flipper__primary">{frontText}</div>
        {frontAdditionalText && (
          <div className="card-flipper__secondary">{frontAdditionalText}</div>
        )}
      </div>
    </div>
    <div className={"card-flipper__face card-flipper__face--back" + smallerBack} >
      {renderControls()}
      <div className="card-flipper__content">
        <div className="card-flipper__primary">{backText}</div>
        {backAdditionalText && (
          <div className="card-flipper__secondary">{backAdditionalText}</div>
        )}
      </div>
    </div>
  </div>
  )}
</div>
</div>
    </div>
    </>
  )
}

export default FlipCard;
